import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";

@Entity({
	one: 'course_one',
	many: 'course_many'
})
export default class Course {

	@Field()
	public id: ID;

	@Field()
	public title: string;

	@Field()
	public displayStartDate: string;

	@Field()
	public displayEndDate: string;

}



// WEBPACK FOOTER //
// ./src/panels/entriesCalendar/entities/Course.ts